import React from "react";
import { Container } from "semantic-ui-react";

const Guiding = () => (
  <Container id="Guiding" className="main_content">
    <h1>Guiding</h1>
    <p>
      Verlieren Sie keine kostbare Urlaubszeit durch suchen der Fische oder das
      Einstellen auf die richtige Taktik. Alle unsere Guides sind hauptberuflich
      am Fluss Po tätig. Alle unsere Guides sind deutschsprachig und zählen zu
      den besten Welsanglern in Europa.
    </p>
    <p>
      Alle unsere Guiding-Angebote sind all inklusive. Das bedeutet alles was du
      zum angeln benötigst wird von uns gestellt. Du benötigst nur deine
      persönlichen Dinge, wie Kleidung Schlafsack Kopflampe usw.
    </p>
  </Container>
);

export default Guiding;



// WEBPACK FOOTER //
// ./src/components/Guiding/index.js